{
    "fg" :
    {
        "black"                             : "\u001b[30m",
        "red"                               : "\u001b[31m",
        "green"                             : "\u001b[32m",
        "yellow"                            : "\u001b[33m",
        "blue"                              : "\u001b[34m",
        "magenta"                           : "\u001b[35m",
        "cyan"                              : "\u001b[36m",
        "white"                             : "\u001b[37m",
        "grey"                              : "\u001b[90m",
        "brightBlack"                       : "\u001b[90m",
        "brightRed"                         : "\u001b[91m",
        "brightGreen"                       : "\u001b[92m",
        "brightYellow"                      : "\u001b[93m",
        "brightBlue"                        : "\u001b[94m",
        "brightMagenta"                     : "\u001b[95m",
        "brightCyan"                        : "\u001b[96m",
        "brightWhite"                       : "\u001b[97m",
        "brightGrey"                        : "\u001b[90m",
        "reset"                             : "\u001b[39m"
    },

    "bg" :
    {
        "black"                             : "\u001b[40m",
        "red"                               : "\u001b[41m",
        "green"                             : "\u001b[42m",
        "yellow"                            : "\u001b[43m",
        "blue"                              : "\u001b[44m",
        "magenta"                           : "\u001b[45m",
        "cyan"                              : "\u001b[46m",
        "white"                             : "\u001b[47m",
        "grey"                              : "\u001b[100m",
        "brightBlack"                       : "\u001b[100m",
        "brightRed"                         : "\u001b[101m",
        "brightGreen"                       : "\u001b[102m",
        "brightYellow"                      : "\u001b[103m",
        "brightBlue"                        : "\u001b[104m",
        "brightMagenta"                     : "\u001b[105m",
        "brightCyan"                        : "\u001b[106m",
        "brightWhite"                       : "\u001b[107m",
        "brightGrey"                        : "\u001b[100m",
        "reset"                             : "\u001b[49m"
    },

    "attr" :
    {
        "reset"                             : "\u001b[0m",
        "bold"                              : "\u001b[1m",
        "dim"                               : "\u001b[2m",
        "italic"                            : "\u001b[3m",
        "underline"                         : "\u001b[4m",
        "blink"                             : "\u001b[5m",
        "rapidBlink"                        : "\u001b[6m",
        "inverse"                           : "\u001b[7m",
        "hidden"                            : "\u001b[8m",
        "strikethrough"                     : "\u001b[9m",
        "doubleUnderline"                   : "\u001b[21m",
        "framed"                            : "\u001b[51m",
        "encircled"                         : "\u001b[52m",
        "overlined"                         : "\u001b[53m"
    },

    "cursor" :
    {
        "savePosition"                      : "\u001b[s",
        "restorePosition"                   : "\u001b[u",
        "hide"                              : "\u001b[?25l",
        "show"                              : "\u001b[?25h",
        "nextLine"                          : "\u001b[E",
        "prevLine"                          : "\u001b[F",
        "forward"                           : "\u001b[G",
        "backward"                          : "\u001b[H",
        "moveTo"                            : "\u001b[{line};{column}H"
    },

    "erase" :
    {
        "line"                              : "\u001b[2K",
        "screen"                            : "\u001b[2J",
        "down"                              : "\u001b[J"
    },

    "scroll" :
    {
        "up"                                : "\u001b[S",
        "down"                              : "\u001b[T"
    },

    "misc":
    {
        "resetAll"                          : "\u001b[0m",
        "resetCursor"                       : "\u001b[?25l\\u001b[?0c",
        "resetColors"                       : "\u001b[39;49m",
        "resetScreen"                       : "\u001b[2J\\u001b[1;1H",
        "resetLine"                         : "\u001b[2K\\u001b[1G"
    }
}